import { FaFacebookSquare, FaInstagram } from "react-icons/fa";
import { SlGlobe } from "react-icons/sl";
import { IoLogoYoutube } from "react-icons/io5";

export function NGOCard({ logo, alt, links = {} }) {
  const className = alt.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="arasamtavrobo-div">
      <img src={logo} alt={alt} className={`ara-photo ${className}`} />
      <div className={`arasamtavrobo-icons ${className}`}>
        {links.website && (
          <a href={links.website} target="_blank" rel="noopener noreferrer">
            <SlGlobe className="first" />
          </a>
        )}
        {links.facebook && (
          <a href={links.facebook} target="_blank" rel="noopener noreferrer">
            <FaFacebookSquare className="second" />
          </a>
        )}
        {links.instagram && (
          <a href={links.instagram} target="_blank" rel="noopener noreferrer">
            <FaInstagram className="third" />
          </a>
        )}
        {links.youtube && (
          <a href={links.youtube} target="_blank" rel="noopener noreferrer">
            <IoLogoYoutube className="fourth" />
          </a>
        )}
      </div>
    </div>
  );
}